import { Dispatch, SetStateAction } from "react";
import {
  Modal,
  Button,
  TextField,
  MenuItem,
  Select,
  SelectChangeEvent,
  FormControl,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import React from "react";

interface ModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
  type?: string;
}

export default function AddServiceFee({
  open,
  onClose,
  setOpen,
  type = "add",
}: ModalProps) {
  const [Category, setCategory] = React.useState("default");
  const handleCategoryChange = (event: SelectChangeEvent) => {
    setCategory(event.target.value as string);
  };

  const [FeeType, setFeeType] = React.useState("default");
  const handleFeeTypeChange = (event: SelectChangeEvent) => {
    setFeeType(event.target.value as string);
  };

  return (
    <Modal className="modal addCategory_modal" open={open} onClose={onClose}>
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="modal_title">
            <h2>{type === "edit" ? "Edit Service Fee" : "Add Service Fee"}</h2>
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={() => setOpen(false)}
            >
              <CloseIcon />
            </button>
          </div>

          <form className="form">
            <div className="gap_p">
              {/* Category */}
              <div className="control_group w_100">
                <label htmlFor="category">Category</label>
                <FormControl fullWidth>
                  <Select
                    id="category"
                    value={Category}
                    onChange={handleCategoryChange}
                  >
                    <MenuItem disabled value="default">
                      Select Category
                    </MenuItem>
                    <MenuItem value="1">For Men</MenuItem>
                    <MenuItem value="2">For Women</MenuItem>
                  </Select>
                </FormControl>
              </div>

              {/* Fee Type */}
              <div className="control_group w_100">
                <label htmlFor="feeType">Fee Type</label>
                <FormControl fullWidth>
                  <Select
                    id="feeType"
                    value={FeeType}
                    onChange={handleFeeTypeChange}
                  >
                    <MenuItem disabled value="default">
                      Select Fee Type
                    </MenuItem>
                    <MenuItem value="1">Percentage</MenuItem>
                    <MenuItem value="2">Flat</MenuItem>
                  </Select>
                </FormControl>
              </div>

              {/* Conditional fields */}
              {FeeType === "1" && (
                <div className="control_group w_100">
                  <label htmlFor="discount">Discount (%)</label>
                  <TextField
                    id="discount"
                    fullWidth
                    placeholder="Enter % Discount"
                  />
                </div>
              )}

              {FeeType === "2" && (
                <div className="control_group w_100">
                  <label htmlFor="feeAmount">Fee Amount</label>
                  <TextField
                    id="feeAmount"
                    fullWidth
                    placeholder="Enter Fee Amount"
                  />
                </div>
              )}
            </div>

            <div className="footer_btn_flex">
              <Button className="btn btn_grey" onClick={() => setOpen(false)}>
                Cancel
              </Button>
              <Button className="btn btn_primary" onClick={() => setOpen(false)}>
                Submit
              </Button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
}
